import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import Translation from "../../i18n/Translation";
import UserAvatarPresenter from '../user-avatar/UserAvatarPresenter';
import Responsive from "../../utils/Responsive";
import Svg from "../../../../svg/Svg";


export default class UserHeaderDropdownPresenter extends React.Component {

    static propTypes = {
        user: PropTypes.object
    };

    redirectToPage(currentLanguage, redirectLanguage) {
        let currentUrl = window.location.href;
        if(currentUrl.indexOf(currentLanguage) !== -1) {
            return currentUrl.replace(`/${currentLanguage}/`, `/${redirectLanguage}/`);
        } else {
            return `/${redirectLanguage}/mywort`; // Redirect to homepage if there is no language param in the url
        }
    }

    renderLanguageSwitcher = () => {
        const lang = Translation.getLanguageName();

        return(
            <div className="language-switcher">
                <a title="Deutsch" className={classNames("language-switcher__link", {"language-switcher__link--active" : lang === "de"})} href={this.redirectToPage(lang, "de")}>DE</a>
                <a title="Français" className={classNames("language-switcher__link", {"language-switcher__link--active" : lang === "fr"})} href={this.redirectToPage(lang, "fr")}>FR</a>
                <a title="English" className={classNames("language-switcher__link", {"language-switcher__link--active" : lang === "en"})} href={this.redirectToPage(lang, "en")}>EN</a>
            </div>
        );
    }

    renderListItems = () => {
        return(
            <div>
                <a className="menu-items__item mywort-btn" href={"/" + Translation.getLanguageName() + "/mywort/edit#/post/create"}>{Translation.translate("user-module.add-post")}</a>
                { !Responsive.isMobile() ? <a className="menu-items__item mywort-btn" href={"/" + Translation.getLanguageName() + "/mywort/edit#/group"}>{Translation.translate("user-module.my-groups")}</a> : null }
                <a className="menu-items__item mywort-btn" href={'/'+Translation.getLanguageName()+'/user-space'}>{Translation.translate("user-module.profile")}</a>
                <a className="menu-items__item mywort-btn" href={"/" + Translation.getLanguageName() + "/mywort/faq"}>{Translation.translate("user-module.faq")}</a>
                <a className="menu-items__item mywort-btn" href="/oauth/logout">{Translation.translate("user-module.logout")}</a>
                { this.renderLanguageSwitcher() }
            </div>
        )
    };

    render = () => {

        if(!this.props.user){
            return (
                <div>
                    <a href={'/oauth/login?lang=' + Translation.getLanguageName() + '&referrer=' + window.location.pathname} className="mywort-btn mywort-btn--outlined-transparent mywort-btn--radius mywort-header__btn u-text-uppercase">
                        <Svg id="user_full" className="mywort-header__btn__svg"/> <span className="hide-for-small">{Translation.translate("user-module.signup-login")}</span>
                    </a>
                    <div className="header-dropdown">
                        <button className="mywort-btn mywort-btn--outlined-transparent mywort-btn--radius mywort-header__btn u-text-uppercase mywort-header__language-btn">
                            <span className="hide-for-small">{Translation.getLanguageName().toUpperCase()}</span><Svg id="chevron" className="mywort-dropdown__chevron"/>
                        </button>
                        <div className="mywort-dropdown__content mywort-dropdown__menu" style={{display:'none'}}>
                            <div className="menu-items">
                                { this.renderLanguageSwitcher() }
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        if(this.props.user.myWortAccess === false){
            return null;    //hide it for blocked users
        }

        return (
            <div className="header-dropdown">
                <button className="mywort-btn mywort-header__user-btn">
                    <UserAvatarPresenter className={"mywort-avatar mywort-avatar--header"}  user={this.props.user}/>
                    <Svg id="chevron" className="mywort-dropdown__chevron"/>
                </button>
                <div className="mywort-dropdown__content mywort-dropdown__menu" style={{display:'none'}}>
                    <div className="menu-items">
                        { this.renderListItems() }
                    </div>
                </div>
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./js/mywort/commons/components/user-header-dropdown/UserHeaderDropdownPresenter.jsx